import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import { useLanguage } from '@/context/language-context';

const Index = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();

  // Redirection immédiate vers la page Explore avec le préfixe de langue
  useEffect(() => {
    if (currentLanguage) {
      navigate(`/${currentLanguage}/explore`, { replace: true });
    }
  }, [navigate, currentLanguage]);

  // Rendre un indicateur de chargement minimal dans le Layout pendant la redirection
  return (
    <Layout>
      <div>Chargement...</div> 
    </Layout>
  );
};

export default Index;
